<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <div class="content">
          <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="LoanReports"
              @submit.prevent="handleSubmit"
            >
              <!-- Applicant Information -->
              <!-- <div class="columns">
                <div class="column">
                  <h1><b>Internal Only</b></h1>
                </div>
              </div>

              <div class="columns is-centered">
                <div class="columns">
                  Applicant Name
                  <div class="column">
                    <h2>Applicant Name</h2>
                    <vee-textbox
                      v-model="ApplicantName"
                      placeholder="Applicant Name"
                      required
                      rules="required"
                    />
                  </div> -->

              <!-- Applicant Email -->
              <!-- <div class="column">
                    <h2>Applicant Email Address</h2>
                    <vee-textbox
                      v-model="ApplicantEmail"
                      type="email"
                      placeholder="Applicant Email Address"
                      required
                      rules="required|email"
                    />
                  </div> -->

              <!-- Property Address Search -->
              <!-- <div class="column">
                    <h2>Property Address</h2>
                    <textbox
                      v-model="addressSearch"
                      name="txt-tenant-address-search"
                      placeholder="Search for a Address"
                      @input="handleAddressInput"
                    />
                  </div>
                </div>
              </div> -->

              <!-- Address Candidates Table -->
              <!-- <div class="columns" v-if="showCandidateTable">
                <div class="column">
                  <div class="table-container">
                    <div v-if="addressCandidatesLoaded">
                      <h4 v-if="addressCandidates.length > 1">
                        We've found multiple addresses like that, please select
                        yours from the list below, or add more information to
                        the search above to narrow your results
                      </h4>
                      <h4 v-else-if="addressCandidates.length === 1">
                        We've found a property like the one you entered above,
                        please select it from below to auto populate the tenant
                        address fields. Please fill in the apartment / unit
                        number below for the tenant if applicable.
                      </h4>
                      <table
                        class="table is-fullwidth"
                        v-if="addressCandidates.length > 0"
                      >
                        <thead>
                          <tr>
                            <th>Address</th>
                            <th>ZIP Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="candidate in addressCandidates"
                            :key="candidate.id"
                          >
                            <td>
                              <input
                                :id="'candidate-' + candidate.id"
                                type="radio"
                                name="selectedCandidate"
                                :checked="candidate.selected"
                                @click="setSelectedAddress(candidate)"
                              />
                              <label
                                class="address-label ml-2"
                                :for="'candidate-' + candidate.id"
                              >
                                {{ candidate.StreetAddress }}
                              </label>
                            </td>
                            <td>{{ candidate.ZipCode }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="has-text-centered py-4">
                      <span>Loading...</span>
                    </div>
                  </div>
                  <div
                    v-if="addressCandidatesNotFound"
                    class="notification is-warning"
                  >
                    <span>No Address Found. Please Enter Manually.</span>
                  </div>
                </div>
              </div> -->

              <!-- Address Details -->
              <!-- <div class="columns is-centered">
                <div class="column is-two-thirds">
                  <div class="columns">
                    <div class="column">
                      <vee-textbox
                        type="address-line1"
                        v-model="address.Street1"
                        name="txt-tenant-address-street1"
                        placeholder="Street Address"
                        rules="required"
                        required
                        :readonly="!addressCandidatesNotFound"
                        :disabled="!addressCandidatesNotFound"
                        autocomplete="address-line1"
                      />
                    </div>
                    <div class="column">
                      <textbox
                        type="address-line2"
                        v-model="address.Street2"
                        name="txt-tenant-address-street2"
                        placeholder="Apt / Unit"
                        autocomplete="address-line2"
                      />
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column">
                      <vee-textbox
                        type="city"
                        v-model="address.City"
                        name="txt-tenant-address-city"
                        placeholder="City"
                        autocomplete="address-level2"
                      />
                    </div>
                    <div class="column">
                      <vee-textbox
                        type="state"
                        v-model="address.State"
                        name="txt-tenant-address-state"
                        placeholder="State"
                        autocomplete="address-level1"
                      />
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column">
                      <vee-textbox
                        type="postal-code"
                        v-model="address.Zip"
                        name="txt-tenant-address-zip"
                        placeholder="ZIP Code"
                        rules="required"
                        required
                        readonly
                        :disabled="!addressCandidatesNotFound"
                        autocomplete="postal-code"
                      />
                    </div>
                    <div class="column">
                      <vee-textbox
                        type="country"
                        v-model="address.Country"
                        name="txt-tenant-address-country"
                        label="Country"
                        readonly
                        disabled
                        autocomplete="country"
                      />
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Property Details -->
              <div class="columns">
                <div class="column">
                  <h2><b>Property Details</b></h2>
                </div>
              </div>
              <div class="column">
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      type="select"
                      v-model="numOfUnits"
                      :options="unitOptions"
                      name="num-of-units"
                      placeholder="Number of units"
                      rules="required"
                      text-field="text"
                      value-field="id"
                      @change="createUnitObjects(numOfUnits)"
                    />
                  </div>
                  <div class="column">
                    <vee-textbox
                      type="text"
                      v-model="titleNames"
                      name="title-name"
                      label="Name(s) on Title"
                      placeholder="Name(s) on title"
                      rule="required"
                    />
                  </div>
                  <div class="column">
                    <vee-dropdown
                      type="select"
                      v-model="ownershipTypeSelected"
                      :options="ownershipType"
                      name="ownership-type"
                      placeholder="Type of ownership"
                      rules="required"
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label for=""
                      ><b
                        >Please enter the social security number (SSN),
                        Individual Taxpayer Identification Number (ITIN), or
                        Employer Identification Number (EIN) that you use to
                        file taxes for this property.</b
                      ></label
                    >
                    <vee-textbox
                      type="text"
                      v-model="ssn"
                      name="id-type"
                      placeholder="Please enter the (SSN) number you use to file taxes for this property."
                      rules="required"
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label for=""
                      >Which type of identification number did you enter?</label
                    >
                    <vee-dropdown
                      type="select"
                      v-model="idTypeSelected"
                      :options="idType"
                      name="id-type"
                      rules="required"
                      value-field="id"
                    />
                  </div>
                  <div class="column">
                    <label for=""
                      >Do you have a rental license for this property?</label
                    >
                    <vee-dropdown
                      type="select"
                      v-model="rentalLicense"
                      :options="radioOptions"
                    />
                  </div>
                  <div class="column">
                    <label for=""
                      >Do you have property insurance for this property?</label
                    >
                    <vee-dropdown
                      type="select"
                      v-model="propertyInsurance"
                      :options="radioOptions"
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label for=""
                      >Are there any currently unresolved code violations at
                      this property?
                    </label>
                    <vee-dropdown
                      type="select"
                      v-model="codeViolations"
                      :options="radioOptions"
                    />
                  </div>
                  <div class="column">
                    <label for=""
                      >Are you behind on any mortgage payments or otherwise
                      delinquent on any debt associated with this
                      property?</label
                    >
                    <vee-dropdown
                      type="select"
                      v-model="missedPayments"
                      :options="radioOptions"
                    />
                  </div>
                  <div class="column">
                    <br />
                    <label for=""
                      >Have you completed a lead dust wipe test at this
                      property?</label
                    >
                    <vee-dropdown
                      type="select"
                      v-model="leadTest"
                      :options="radioOptions"
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      type="select"
                      v-model="heatTypeSelected"
                      :options="heatType"
                      name="heat-type"
                      placeholder="What type of heat does the property have?"
                      rules="required"
                    />
                  </div>
                  <div class="column">
                    <vee-dropdown
                      type="select"
                      v-model="waterHeatTypeSelected"
                      :options="waterHeatType"
                      name="water-heat-type"
                      placeholder="What type of water heater does the property have?"
                      rules="required"
                    />
                  </div>
                </div>
              </div>

              <!-- Loan Details -->
              <div class="columns">
                <div class="column">
                  <h2><b>Loan Details</b></h2>
                </div>
              </div>
              <div class="column">
                <h5><b>Which type of loan are you applying for?</b></h5>
                <p>25K/10 Years</p>
              </div>
              <div class="columns">
                <div class="column">
                  <label for=""
                    >Are you planning to repair only the interior of specific
                    units, and/or the overall building (roofing, electrical,
                    masonry, etc.)?</label
                  >
                  <vee-dropdown
                    type="select"
                    v-model="repairPlanningSelected"
                    :options="repairPlanning"
                    name="repair-planning"
                    rules="required"
                    text-field="text"
                    value-field="id"
                  />

                  <vee-checkbox
                    v-model="buildSystemRepairtype"
                    :options="[
                      'Are you planning repairs to building systems (HVAC, structural, mechanical, electrical, plumbing, fire protection)?'
                    ]"
                  />

                  <vee-checkbox
                    v-model="exteriorRepairtype"
                    :options="[
                      'Are you planning repairs to the exterior of the building?'
                    ]"
                  />

                  <vee-checkbox
                    v-model="interiorRepairtype"
                    :options="[
                      'Are you planning repairs to the interior of the building?'
                    ]"
                  />

                  <vee-checkbox
                    v-model="healthRepairtype"
                    :options="[
                      'Are you planning to make health-related repairs or upgrades?'
                    ]"
                  />
                </div>
              </div>

              <div class="column">
                <label for=""
                  >Please briefly describe the repairs you would like to
                  complete at this property.*
                </label>
                <text-area v-model="AmountOfProperties" />
              </div>

              <!-- Cost Estimates -->
              <div class="columns">
                <div class="column">
                  <h2><b>Cost Estimates</b></h2>
                </div>
              </div>
              <div class="column">
                <p>
                  The Rental Improvement Fund requires that an additional 20% of
                  the estimated project cost be set aside to cover possible cost
                  overruns, called contingencies. RIF borrowers can:
                </p>
                <p>
                  1 (set aside 20% of the loan to cover potential cost overruns
                </p>
                <p>OR</p>
                <p>
                  2) use their own funds to start the repair work and the RIF
                  loan will cover the rest, up to the total loan amount.
                </p>
              </div>

              <div class="columns">
                <div class="column">
                  <h5>Estimated cost of drawings and permits</h5>
                  <vee-textbox
                    type="currency"
                    v-model="formData.drawingsPermitsCost"
                    name="drawings-permits-cost"
                    placeholder="Enter cost"
                    rules="required"
                    required
                    @input="calculateTotals"
                  />
                </div>

                <div class="column">
                  <h5>Estimated construction costs</h5>
                  <vee-textbox
                    type="currency"
                    v-model="formData.constructionCost"
                    name="construction-cost"
                    placeholder="Enter cost"
                    rules="required"
                    required
                    @input="calculateTotals"
                  />
                </div>

                <div class="column">
                  <h5>Required Contingency</h5>
                  <textbox
                    :value="'$' + formData.contingency.toFixed(2)"
                    readonly
                    disabled
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <h5>Total Cost Estimate</h5>
                  <textbox
                    :value="'$' + formData.totalCost.toFixed(2)"
                    readonly
                    disabled
                  />
                </div>

                <div class="column">
                  <h5>Maximum loan amount for loan type selected</h5>
                  <textbox
                    :value="'$' + maxLoanAmount.toLocaleString()"
                    readonly
                    disabled
                  />
                </div>

                <div class="column">
                  <h5>RIF Loan Amount</h5>
                  <textbox
                    :value="'$' + formData.rifLoanAmount.toFixed(2)"
                    readonly
                    disabled
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <h5>
                    Proof of Contingency Fund
                  </h5>
                  <div class="file">
                    <ul
                      class="upload-list"
                      v-if="contractorDocuments.length > 0"
                    >
                      <li
                        v-for="file in contractorDocuments"
                        :key="file.id"
                        class="mb-2"
                      >
                        <span>{{ file.name }}</span>

                        <span v-if="file.error" class="text-red-500 ml-2">
                          Error: {{ file.error }}
                        </span>

                        <span
                          v-else-if="file.success"
                          class="text-green-500 ml-2"
                        >
                          Upload Successful
                        </span>

                        <span
                          v-else-if="file.uploading"
                          class="text-orange-500 ml-2"
                        >
                          Uploading...
                        </span>

                        <button
                          v-if="!file.uploading"
                          @click="removeFile(file.id)"
                          class="ml-2 text-red-500 hover:text-red-700"
                        >
                          Remove
                        </button>
                      </li>
                    </ul>

                    <file-upload
                      ref="upload"
                      v-model="contractorDocuments"
                      :input-id="`file-upload-contractor-docs`"
                      extensions="gif,jpg,jpeg,png,webp,pdf"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,image/jpg"
                      :size="1024 * 1024 * 4.5"
                      @input-filter="inputFilter"
                      class="mt-4"
                    >
                      <button class="button is-primary">
                        <i class="fas fa-plus mr-2"></i>
                        Select File to Upload
                      </button>
                    </file-upload>
                  </div>
                </div>
              </div>

              <!-- Units -->
              <div v-if="unitDetails.length > 0">
                <div
                  v-for="(unit, index) in unitDetails"
                  :key="index"
                  class="mb-8"
                >
                  <div class="columns">
                    <div class="column">
                      <h2>
                        <b>Unit {{ index + 1 }}</b>
                      </h2>
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column">
                      <h5>Unit Number</h5>
                      <vee-textbox
                        v-model="unit.unitNumber"
                        :name="'unit-number-' + (index + 1)"
                        placeholder="Enter unit number"
                        rules="required"
                        required
                      />
                    </div>

                    <div class="column">
                      <h5>Number of bedrooms</h5>
                      <vee-dropdown
                        v-model="unit.bedrooms"
                        :options="bedroomOptions"
                        :name="'bedrooms-' + (index + 1)"
                        placeholder="Select number of bedrooms"
                        rules="required"
                        required
                      />
                    </div>

                    <div class="column">
                      <h5>Is this unit occupied?</h5>
                      <vee-dropdown
                        v-model="unit.isOccupied"
                        :options="yesNoOptions"
                        :name="'is-occupied-' + (index + 1)"
                        placeholder="Select option"
                        rules="required"
                        required
                      />
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column" v-if="unit.isOccupied === 'No'">
                      <h5 style="line-height: .9;">
                        Is this unit vacant because it needs repairs in order to
                        be fully habitable?
                      </h5>
                      <vee-dropdown
                        v-model="unit.isVacant"
                        :options="yesNoOptions"
                        :name="'is-vacant-' + (index + 1)"
                        placeholder="Select option"
                        rules="required"
                        required
                      />
                    </div>

                    <div class="column">
                      <h5>Do you intend to repair this unit?</h5>
                      <vee-dropdown
                        v-model="unit.needsRepair"
                        :options="yesNoOptions"
                        :name="'needs-repair-' + (index + 1)"
                        placeholder="Select option"
                        rules="required"
                        required
                      />
                    </div>

                    <div class="column">
                      <h5>Do you (property owner) live in this unit?</h5>
                      <vee-dropdown
                        v-model="unit.ownerOccupied"
                        :options="yesNoOptions"
                        :name="'owner-occupied-' + (index + 1)"
                        placeholder="Select option"
                        rules="required"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Third Party Authorization -->
              <div class="columns">
                <div class="column">
                  <h2><b>Third Party Authorization</b></h2>
                </div>
              </div>
              <div class="column">
                <h5>
                  <b
                    >You can grant third party authorization to allow someone
                    other than yourself to speak with RIF staff regarding your
                    loan application. If you choose to do so, provide their
                    contact information below. You must complete and sign the
                    RIF Third Party Authorization Form to finalize the
                    designation.</b
                  >
                </h5>
              </div>

              <div class="columns">
                <div class="column">
                  <h5>Third Party Name</h5>
                  <vee-textbox
                    v-model="thirdPartyName"
                    placeholder="Third Party Name"
                  />
                </div>

                <div class="column">
                  <h5>Type of Third Party</h5>
                  <vee-dropdown
                    type="select"
                    v-model="thirdPartyTypeSelected"
                    :options="thirdPartyType"
                    name="third-party-type"
                    text-field="text"
                    value-field="id"
                  />
                </div>

                <div class="column">
                  <h5>Third Party Phone Number</h5>
                  <div class="is-flex space-x-2">
                    <vee-textbox
                      v-model="thirdPartyNumber"
                      name="third-party-phone-number"
                      placeholder="Phone Number"
                      class="mr-2"
                    />
                    <vee-textbox
                      v-model="thirdPartyExt"
                      name="third-party-ext"
                      placeholder="Ext."
                      style="width: 100px;"
                    />
                  </div>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <h5>Third Party Email</h5>
                  <vee-textbox
                    v-model="thirdPartyEmail"
                    placeholder="Third Party Email"
                  />
                </div>

                <div class="column">
                  <h5>Other (please specify)</h5>
                  <vee-textbox
                    v-model="thirdPartyOther"
                    placeholder="Other (please specify)"
                  />
                </div>
              </div>

              <div class="columns">
                <h2><b>Sign and Submit</b></h2>
              </div>
              <div class="columns">
                <div class="column">
                  <p>
                    I/We hereby certify that: - I/We is/are the sole owner(s) of
                    the property/ies included in this application (the
                    "Properties"), and no other person or entity holds an
                    ownership interest in the Properties.
                  </p>
                  <br />

                  <p>
                    - I/We have an ownership stake in NO MORE THAN FIVE (5)
                    PROPERTIES AND NO MORE THAN FIFTEEN (15) RENTAL UNITS IN THE
                    AGGREGATE.
                  </p>
                  <br />

                  <p>
                    - I/We rent the Property for use as a primary residence for
                    a fee, regardless of the length or form of the lease.
                  </p>
                  <br />

                  <p>
                    - I/We have applied for a loan (the "Loan") under the
                    Philadelphia Housing Development Corporation ("PHDC") Rental
                    Improvement Fund (the "Program") to fund certain repairs at
                    the Property (the "Repairs").
                  </p>
                  <br />

                  <p>
                    - I/We understand and acknowledge that I/we must maintain a
                    valid City of Philadelphia rental license for the entire
                    term of the Loan. - If I/We do not have a valid City of
                    Philadelphia rental license, I/we shall obtain such rental
                    license no more than six (6) months of completion of the
                    Repairs.
                  </p>
                  <br />

                  <p>
                    - I/We understand and acknowledge that I/we must maintain
                    property and liability insurance with respect to the
                    Property in amounts and coverages acceptable to PHDC, for
                    the entire term of the Loan.
                  </p>
                  <br />

                  <p>
                    - I/We shall maintain:
                  </p>
                  <br />

                  <p>
                    (A) property insurance with replacement cost coverage in an
                    amount sufficient to cover the replacement cost value of the
                    Property following completion of the Repairs, which names
                    PHDC as a mortgagee on such policy, and is otherwise
                    satisfactory to PHDC in form and substance and
                  </p>
                  <br />

                  <p>
                    (B) liability insurance in an amount not less than Three
                    Hundred Thousand Dollars ($300,000.00), which names PHDC as
                    an additional insured on such policy, and is otherwise
                    satisfactory to PHDC in form and substance, and I/we shall
                    provide to PHDC evidence of such property and liability
                    insurance.
                  </p>
                  <br />

                  <p>
                    - I/We understand and acknowledge that we may not cause,
                    suffer or maintain any act or omission that may result in a
                    notice of violation with respect to the Property (a
                    "violation") issued by the City of Philadelphia Department
                    of Licenses and Inspections ("L&I") for the entire term of
                    the Loan.
                  </p>
                  <br />

                  <p>
                    - If at any time during the term of the Loan, a violation is
                    issued, I/we shall correct such violation within six (6)
                    months of receipt of notice of such violation.
                  </p>
                  <br />

                  <p>
                    - I authorize, and give my consent to, PHDC, and its
                    officers, agents, employees, representatives, successors,
                    and assigns, to use, share, provide, distribute,
                    disseminate, disclose, make available, receive, analyze, and
                    discuss any and all information that I included in the
                    Application, whether such information is about me or
                    properties I own, including, but not limited to, any and all
                    personally identifiable information (e.g., name(s), home
                    address, date(s) of birth, etc.) and contact information
                    (e.g., home telephone number, cell phone number, email
                    address, etc.) the Philadelphia Redevelopment Authority, the
                    City of Philadelphia (the "City") and any department or
                    agency of the City, any and all entities that may manage,
                    administer, fund, and/or service the Program, and the
                    respective officers, agents, employees, representatives,
                    successors, and assigns of any of the foregoing.
                  </p>
                  <br />

                  <p>
                    - The information listed hereinabove is true and correct.
                  </p>
                  <br />

                  <p>
                    I understand that it is a federal offense (18 U.S. Code
                    Â§1001) and state offense (18 Pa.C.S.A. Â§4904) to knowingly
                    make a false statement in this affidavit.
                  </p>
                  <br />

                  <p>
                    I have read the information carefully to be sure that the
                    information contained herein is true and complete before
                    signing. I understand that the information provided in this
                    affidavit is subject to verification.
                  </p>
                  <br />

                  <p>
                    I understand that my completion of this affidavit or any
                    other document related thereto does not represent any
                    commitment or obligation to be awarded or provided a grant
                    under the Philadelphia Housing Development Corporation
                    (PHDC) Rental Improvement Fund.
                  </p>
                  <br />

                  <p>
                    I agree that this affidavit may be electronically signed,
                    that any electronic signature appearing on this affidavit is
                    the same as a handwritten signature for the purposes of
                    validity, enforceability, and admissibility, and that a
                    signature provided through electronic means may not be
                    denied legal effect solely because it is in electronic form.
                    I understand that by typing my name below, it will serve as
                    my electronic signature.
                  </p>
                  <br />

                  <p>
                    I affix my name hereto and understand that any false or
                    misleading statements or omissions made herein or in any
                    other documentation or information submitted by me or on my
                    behalf in connection with a Rental Improvement Fund loan may
                    result in the denial of my Rental Improvement Fund loan
                    application and my disqualification from this or any future
                    PHDC assistance programs, and further may result in criminal
                    and civil actions for fines, penalties, damages, or
                    imprisonment.
                  </p>
                  <br />
                </div>
              </div>

              <div class="mt-8 mb-4">
                <label class="flex items-center">
                  <input
                    type="checkbox"
                    v-model="agreeToTerms"
                    class="form-checkbox"
                    required
                    rules="required"
                  />
                  <span class="ml-2">
                    <p>Agree to terms of program*</p>
                    <br /><br />
                  </span>
                </label>
              </div>

              <!--Signature -->
              <div class="columns">
                <div class="column">
                  <h5>Signature of Declarant</h5>
                  <vee-textbox
                    type="text"
                    v-model="signature"
                    placeholder="signature"
                    required
                    rules="required"
                  />
                </div>

                <!-- Date -->
                <div class="column">
                  <h5>Date</h5>
                  <vee-textbox
                    v-model="appDate"
                    type="date"
                    name="app-date"
                    placeholder="Select date"
                    :rules="dateRules"
                    required
                  />
                </div>
              </div>

              <div>
                <callout
                  type="danger"
                  v-if="FilesReady == false && missingFilesError != ''"
                >
                  <b>{{ missingFilesError }}</b>
                </callout>
              </div>

              <!-- Submit -->
              <div class="columns mt-8">
                <div class="column is-full has-text-centered">
                  <button
                    class="button is-primary is-large"
                    @click="handleSubmit"
                    :disabled="
                      SubmitStatus.Value === SubmitStatus.Options.PENDING ||
                        FilesReady === false
                    "
                  >
                    Submit Application
                  </button>
                </div>
              </div>
            </input-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import { debounce } from "lodash";
import FileUpload from "vue-upload-component";
import buildLoanReportsDataObject from "@/utilities/loan-reports";
import buildLandlordInfoObject from "@/utilities/get-landlord-info";
import {
  dataObjectToXml,
  getBase64,
  resizeImage,
  getPropertyValueOrDefault
} from "@/utilities/functions";
import Unit from "@/utilities/classes/Units";

export default {
  name: "LoanReports",
  components: {
    FileUpload
  },
  props: {
    email: { default: null, type: String }
  },
  data() {
    return {
      errors: [],
      SubmitStatus: {
        Value: null,
        Options: {
          PENDING: "PENDING",
          ERROR: "ERROR",
          OK: "OK"
        }
      },
      FilesReady: false,
      missingFilesError: "",
      ApplicantName: null,
      // ApplicantEmail: null,
      // addressSearch: null,
      titleNames: null,
      // addressCandidates: [],
      // addressCandidatesLoaded: false,
      // addressCandidatesNotFound: false,
      // showCandidateTable: false,
      idTypeSelected: null,
      //address: null,
      ssn: null,
      rentalLicense: null,
      propertyInsurance: null,
      codeViolations: null,
      missedPayments: null,
      leadTest: null,
      appDate: null,
      AmountOfProperties: null,
      thirdPartyName: null,
      thirdPartyTypeSelected: [],
      thirdPartyType: ["Attorney", "Contractor", "Property Manager", "Other"],
      thirdPartyNumber: null,
      thirdPartyExt: null,
      thirdPartyOther: null,
      thirdPartyEmail: null,
      buildSystemRepairtype: [],
      exteriorRepairtype: [],
      interiorRepairtype: [],
      healthRepairtype: [],
      radioOptions: ["Yes", "No"],
      agreeToTerms: false,
      address: {
        Street1: null,
        Street2: null,
        City: "Philadelphia",
        State: "Pennsylvania",
        Zip: null,
        Country: "United States",
        OpaNumber: null,
        DorNumber: null,
        PwdNumber: null,
        CouncilDistrict: null
      },
      numOfUnits: null,
      heatTypeSelected: null,
      ownershipTypeSelected: null,
      waterHeatTypeSelected: null,
      unitOptions: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15"
      ],
      ownershipType: [
        "My name is on the deed",
        "I am the full owner of the LLC for this property",
        "I am a partial owner of the LLC for this property"
      ],
      heatType: ["Electric", "Natural gas", "Oil", "Other"],
      waterHeatType: ["Electric", "Natural gas", "Oil"],
      idType: [
        "Social Security Number (SSN)",
        "Individual Taxpayer Identification Number (ITIN)",
        "Employer Identification Number (EIN)"
      ],
      repairPlanningSelected: null,
      repairPlanning: [
        "Improvements to the building",
        "Improvements to specific units",
        "Both units and building to be improved"
      ],
      maxLoanAmount: 24999,
      formData: {
        drawingsPermitsCost: null,
        constructionCost: null,
        contingency: 0,
        totalCost: 0,
        rifLoanAmount: 0,
        // isLicensedContractor: "",
        // contractorLicenseNumber: "",
        includesRoofing: false
      },
      contractorDocuments: [],
      unitDetails: [],
      signature: null,
      bedroomOptions: ["0", "1", "2", "3", "4", "5", "6"],
      yesNoOptions: ["Yes", "No"]
    };
  },

  methods: {
    checkForFiles() {
      setInterval(() => {
        this.filesReady();
      }, 1000);
    },

    filesReady() {
      let fileFound = true;

      if (this.contractorDocuments.length <= 0) {
        fileFound = false;
      }

      if (!fileFound) {
        this.missingFilesError = "Missing Proof of Contingency Fund";
      } else {
        this.missingFilesError = "";
      }

      this.FilesReady = fileFound;
    },

    handleFileUploadSuccess(file) {
      file.uploading = false;
      file.success = true;
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }

        if (newFile.size >= 1024 * 1024 * 4.5) {
          newFile.error = "File size exceeds 4.5MB limit";
          return prevent();
        }

        // Add uploading status
        newFile.uploading = true;

        setTimeout(() => {
          this.handleFileUploadSuccess(newFile);
        }, 1500);
      }
    },

    createUnitObjects(numberOfUnits) {
      this.unitDetails = [];
      for (var i = 0; i < numberOfUnits; i++) {
        const unitObj = new Unit(i + 1);
        this.unitDetails.push(unitObj);
      }
      console.log(this.unitDetails);
    },
    dateRules() {
      const today = new Date().toISOString().split("T")[0];
      const nextYear = new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      )
        .toISOString()
        .split("T")[0];

      return {
        required: true,
        date_format: "YYYY-MM-DD",
        after_or_equal: today,
        before_or_equal: nextYear
      };
    },

    // handleAddressInput: debounce(function() {
    //   if (this.addressSearch.length >= 3) {
    //     this.getAddressCandidates();
    //   } else {
    //     this.showCandidateTable = false;
    //     this.addressCandidates = [];
    //   }
    // }, 500),

    // async getAddressCandidates() {
    //   this.addressCandidatesLoaded = false;
    //   this.showCandidateTable = true;
    //   this.addressCandidatesNotFound = false;

    //   try {
    //     const aisUrl = `https://api.phila.gov/ais/v1/search/${encodeURIComponent(
    //       this.addressSearch
    //     )}?gatekeeperKey=2d130e3603f8931d82d39b3913bffe18`;

    //     const response = await axios.get(aisUrl);

    //     if (response?.data?.features?.length) {
    //       this.addressCandidates = response.data.features.map(
    //         (feature, idx) => ({
    //           id: idx,
    //           StreetAddress: feature.properties.street_address,
    //           ZipCode: feature.properties.zip_code,
    //           opaNumber: feature.properties.opa_account_num,
    //           dorNumber: feature.properties.dor_parcel_id,
    //           pwdNumber: feature.properties.pwd_parcel_id,
    //           councilDistrict: feature.properties.council_district_2024,
    //           selected: false
    //         })
    //       );
    //       this.addressCandidatesLoaded = true;
    //     } else {
    //       this.handleNoAddressFound();
    //     }
    //   } catch (error) {
    //     console.error("AIS API Error:", error);
    //     this.handleNoAddressFound();
    //   }
    // },

    // handleNoAddressFound() {
    //   this.showCandidateTable = false;
    //   this.addressCandidatesNotFound = true;
    //   this.addressCandidates = [];
    //   this.enableManualEntry();
    // },

    // enableManualEntry() {
    //   const street1Input = document.getElementById(
    //     "txt-tenant-address-street1"
    //   );
    //   const zipInput = document.getElementById("txt-tenant-address-zip");
    //   if (street1Input) street1Input.removeAttribute("readonly");
    //   if (zipInput) zipInput.removeAttribute("readonly");
    // },

    // setSelectedAddress(candidate) {
    //   this.address = {
    //     ...this.address,
    //     Street1: candidate.StreetAddress,
    //     Zip: candidate.ZipCode,
    //     OpaNumber: candidate.opaNumber,
    //     DorNumber: candidate.dorNumber,
    //     PwdNumber: candidate.pwdNumber,
    //     CouncilDistrict: candidate.councilDistrict
    //   };

    //   // Update selected state in candidates
    //   this.addressCandidates = this.addressCandidates.map(c => ({
    //     ...c,
    //     selected: c.id === candidate.id
    //   }));
    // },
    calculateTotals() {
      const subtotal =
        Number(this.formData.drawingsPermitsCost) +
        Number(this.formData.constructionCost);

      // Calculate 20% contingency
      this.formData.contingency = subtotal * 0.2;

      // Calculate total cost
      this.formData.totalCost = subtotal + this.formData.contingency;

      // Calculate RIF loan amount (cannot exceed maximum)
      this.formData.rifLoanAmount = Math.min(
        this.formData.totalCost,
        this.maxLoanAmount
      );
    },

    async getFile(uploadData) {
      if (uploadData.length) {
        var vData = this;
        let FileIdx = uploadData.length - 1;
        var fileObj = uploadData[FileIdx];
        fileObj.uploading = true;
        fileObj.error = false;
        fileObj.errorMessage = "";
        let file = fileObj.file;
        if (fileObj.type.match(/image.*/)) {
          file = await resizeImage({ file: file, maxSize: 1920 });
        }
        if (
          file.type != "application/pdf" &&
          file.type != "image/png" &&
          file.type != "image/jpeg" &&
          file.type != "image/jpg"
        ) {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage = "Wrong file type";
          throw "Wrong File Type";
        }
        if (file.size >= 1024 * 1024 * 4.5) {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
            "File is too large, please reduce your file's size and try again.";
          throw "File is too large";
        } else {
          return await getBase64(file);
        }
      }
    },

    async handleSubmit() {
      // event prevents submission page from refreshing
      if (event) event.preventDefault();
      try {
        console.log("HERE");
        const isValid = await this.$refs.form.$parent.validate();
        if (!isValid) {
          this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
          return;
        }

        var document = await this.getFile(this.contractorDocuments);
        var documentName = this.contractorDocuments[0].name;

        // console.log('Address data being sent:', {
        //   Street1: this.address.Street1,
        //   Street2: this.address.Street2,
        //   City: this.address.City,
        //   State: this.address.State,
        //   Zip: this.address.Zip,
        //   Country: this.address.Country
        // });

        console.log("HERE");

        console.log(document);

        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;

        const dataObject = buildLoanReportsDataObject(
          this,
          document,
          documentName
        );
        const xmlDataObject = dataObjectToXml(dataObject);
        const requestObject = {
          table: "btbsqbhjn",
          action: "API_AddRecord",
          data: xmlDataObject
        };

        console.log(requestObject);

        axios
          .post(
            `${process.env.VUE_APP_QB_API_URL}loan-report-submit`,
            // "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/Rental-Improvement-Fund-QuickBase-Request-Proxy",
            requestObject
          )
          .then(response => {
            console.log(response);
            this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
            this.$router.push({ name: "SuccessInspection" });
          })
          .catch(err => {
            console.error(err);
            alert(err);
          });
      } catch (error) {
        console.error("Submit error:", error);
        this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
        this.errors.push(error.message || "Failed to submit form");
      }
    },

    removeFile(fileId) {
      const index = this.contractorDocuments.findIndex(f => f.id === fileId);
      if (index !== -1) {
        this.contractorDocuments.splice(index, 1);
      }
    },

    handleRoofingEstimateFilter(newFile, oldFile) {
      if (newFile && !oldFile) {
        if (newFile.size >= 1024 * 1024 * 4.5) {
          newFile.error = "File size exceeds 4.5MB limit";
          return;
        }

        newFile.uploading = true;

        setTimeout(() => {
          newFile.uploading = false;
          newFile.success = true;
          this.handleRoofingUploadSuccess(newFile);
        }, 1500);
      }
    }
  },
  created() {
    this.checkForFiles();
    var vData = this;
    var dataObject = buildLandlordInfoObject(
      vData.email,
      "RIF_GET_LANDLORD_INFO"
    );
    var requestObj = {
      table: "bs2bx26ex",
      data: dataObject
    };
    axios
      .post(
        `${process.env.VUE_APP_QB_API_URL}loan-report-submit`,
        requestObj
      )
      .then(response => {
        console.log(response);
        const responseObject = getPropertyValueOrDefault(
          ["data", "record", "f"],
          response
        );

        vData.address.Street1 = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "46")
        );
        vData.address.Street2 = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "47")
        );
        vData.address.City = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "48")
        );
        vData.address.State = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "49")
        );
        vData.address.Zip = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "50")
        );
        vData.address.Country = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "51")
        );

        vData.ApplicantName = getPropertyValueOrDefault(
          ["_text"],
          responseObject.find(i => i._attributes.id === "40")
        );

        console.log(vData.address);
        console.log(vData.ApplicantName);
      });
  }
};
</script>

<style scoped>
.table-container {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
}

.address-label {
  cursor: pointer;
  padding-left: 0.5rem;
}

.notification {
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 4px;
}

.notification.is-warning {
  background-color: #fff3e0;
  color: #856404;
}
</style>
